import React, { useState } from 'react';

import { Button } from '@components/common';
import DisqualificationPageForm from '@components/GQSurveyBuilder/components/ScreenerConfig/DisqualificationPageForm';
import { useScreenerConfig } from '@components/GQSurveyBuilder/components/ScreenerConfig/useScreenerConfig';
import { CopyURLButton } from '@components/shared/CopyURLButton';
import { compact } from '@components/utils';

const AutoDisqualificationEditPage = (props: PageProps) => {
  const { study, pre_screener } = props;
  const [editing, setEditing] = useState(false);

  const {
    handleSave,
    disqualificationPageTitle,
    setDisqualificationPageTitle,
    disqualificationPageContent,
    setDisqualificationPageContent,
    disqualificationPageTitleError,
    disqualificationPageContentError,
    resetDisqualificationPageToInitialValues
  } = useScreenerConfig(study, pre_screener as Screener);

  const handleCancel = () => {
    setEditing(false);
    resetDisqualificationPageToInitialValues();
  };

  const handleDone = async () => {
    const saved = await handleSave();
    if (saved) {
      setEditing(false);
    }
  };

  const previewDisqualificationPageUrl =
    window.location.origin + '/studies/' + study.id + '/preview/screener?disqualified=true';

  return (
    <div
      className={compact([
        'relative mx-auto w-full max-w-4xl border border-gray-200 bg-white p-8',
        editing && 'rounded-md',
        !editing && 'shadow-lg'
      ]).join(' ')}
    >
      <div className='flex justify-end space-x-3 pb-8'>
        {editing ? (
          <>
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type='submit' primary onClick={handleDone}>
              Done
            </Button>
          </>
        ) : (
          <>
            <Button iconSuffix='externalLink' href={previewDisqualificationPageUrl} target='_blank'>
              View
            </Button>
            <Button iconSuffix='pencil' onClick={() => setEditing(true)}>
              Edit
            </Button>
          </>
        )}
      </div>
      <div>
        <div
          className={`tablet:mb-48 relative z-10 my-8 ${!editing && 'rounded-sm border border-gray-200'} bg-white p-10 text-center`}
        >
          {editing ? (
            <DisqualificationPageForm
              className='custom-disqualification-form text-left'
              disqualificationPageTitle={disqualificationPageTitle}
              setDisqualificationPageTitle={setDisqualificationPageTitle}
              disqualificationPageContent={disqualificationPageContent}
              setDisqualificationPageContent={setDisqualificationPageContent}
              disqualificationPageTitleError={disqualificationPageTitleError}
              disqualificationPageContentError={disqualificationPageContentError}
              isEditPage={true}
            />
          ) : (
            <>
              <h2 role='alert' aria-live='assertive' className='text-custom-brand py-2 text-2xl font-bold'>
                {disqualificationPageTitle}
              </h2>
              <div className='text-custom-brand pb-8'>{disqualificationPageContent}</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AutoDisqualificationEditPage;
